export default {
    components: {},
    props: [],
    data: () => {
        return {
            showPortifolioModal: false,
            modalImg: "",
            modalContent: "",
        };
    },
    beforeMount() {},

    mounted() {
        const getModalTriggerLogin = document.querySelectorAll('a[class="nav-link"]');
        getModalTriggerLogin.forEach(
            function (el) {
                el.addEventListener(
                    "click",
                    function () {
                        let header = document.getElementById("header");
                        if (header.classList.contains("open")) {
                            document.getElementById("header").classList.toggle("open");
                            document.getElementsByTagName("body")[0].classList.toggle("modal-open");
                        }
                    }.bind(this)
                );
            }.bind(this)
        );

        const portifolio = document.querySelectorAll(".container-with-component-class-portifolio .nav-link");
        portifolio.forEach(
            function (el) {
                el.addEventListener(
                    "click",
                    function () {
                        this.openPortifolioModal();
                        const img = el.querySelector("img");

                        const description = el.querySelector(".portifolio-description");
                        this.modalImg = img.src;
                        this.modalContent = description.innerHTML;
                    }.bind(this)
                );
            }.bind(this)
        );

        this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
            this.setModalContent();
        });
    },
    methods: {
        toggleMenu: function () {
            document.getElementById("header").classList.toggle("open");
            document.getElementsByTagName("body")[0].classList.toggle("modal-open");
        },
        openPortifolioModal: function () {
            this.showPortifolioModal = true;
        },
        setModalContent: function () {
            this.$nextTick(() => {
                const portifolioModalContent = document.querySelector(".portifolio-modal > .content");
                portifolioModalContent.innerHTML = this.modalContent;
            });
        },
    },
};
